// @flow

/**
 * Module dependencies.
 */

import { colors, media, units } from 'client/styles';
import { compose } from 'recompose';
import { position } from 'polished';
import { translator } from 'core/utils';
import AccoutAndDeal from 'client/components/how-it-works/account-and-deal';
import Collect from 'client/components/how-it-works/collect';
import Content from 'client/components/content';
import Header from 'client/components/header';
import Layout from 'client/components/core/layout';
import Operation from 'client/components/how-it-works/operation';
import PageContent from 'client/components/core/page-content';
import React, { Component } from 'react';
import StickyNavbarTrigger from 'client/components/core/sticky-navbar/sticky-navbar-trigger';
import Transferring from 'client/components/transferring';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  translate: Function
};

/**
 * `Overlay` component.
 */

const Overlay = styled.div`
  ${position('absolute', '0', '0', '50%', '0')}

  background-color: ${colors.white};
  display: none;

  ${media.min.md`display: block;`}
`;

/**
 * Collect wrapper styles.
 */

const collectWrapperStyles = `
  overflow: hidden;
  padding-bottom: 0;
  padding-top: ${units(5)};
`;

/**
 * `HowItWorks` component.
 */

class HowItWorks extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { translate } = this.props;

    const account = {
      icon: 'illustration-contract-hand-shake',
      text: translate('howItWorks.account.text'),
      title: translate('howItWorks.account.title')
    };

    const deal = {
      icon: 'illustration-charts-in-hand',
      iconLeft: true,
      text: translate('howItWorks.deal.text'),
      title: translate('howItWorks.deal.title')
    };

    return (
      <PageContent background={colors.shadesOfSand2.pampasDarker}>
        <Header
          filename={'how-it-works-header'}
          short
          title={translate('howItWorks.title')}
        />

        <Content
          pullTop
          separator
        >
          <AccoutAndDeal
            leftItem={account}
            rightItem={deal}
          />
        </Content>

        <StickyNavbarTrigger>
          <Layout position={'relative'}>
            <Overlay />

            <Content
              background={colors.brown}
              pullRight
            >
              <Operation
                icon={'illustration-money-withdraw'}
                text={translate('howItWorks.operation.text')}
                textColor={colors.white}
                title={translate('howItWorks.operation.title')}
                titleColor={colors.white}
              />
            </Content>
          </Layout>

          <Content
            background={colors.transparent}
            pullRight
            styles={collectWrapperStyles}
          >
            <Collect
              icon={'illustration-wall-safe-deposit'}
              text={translate('howItWorks.destination.text')}
              title={translate('howItWorks.destination.title')}
              titleColor={colors.brandPrimary}
            />
          </Content>

          <Transferring bgColor={colors.transparent} />
        </StickyNavbarTrigger>
      </PageContent>
    );
  }

}

/**
 * Export `HowItWorks` component.
 */

export default compose(
  translator()
)(HowItWorks);



// WEBPACK FOOTER //
// ../src/client/containers/how-it-works/index.js